import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-updating-sheet-dialog',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, MatButtonModule, MatIconModule],
  templateUrl: './updating-sheet-dialog.component.html',
  styleUrls: ['./updating-sheet-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class UpdatingSheetDialogComponent implements OnInit {
  public message: string = 'Updating the sheet please wait do not switch between workbooks';
  public isLoading: boolean = true;
  public isCompleted: boolean = false;
  public successMessage: string = 'Update completed successfully';
  public totalRecords: number = 0;
  public updatedRecords: number = 0;
  public submittedRecordCount: string | null = null;
  public remainingProcessingMinutes: number | null = null;
  public processingStatus: 'processing' | 'ready' | null = null;
  
  // Track progress for each type
  public publishedCount: number = 0;
  public publishedTotal: number = 0;
  public deletedCount: number = 0;
  public deletedTotal: number = 0;
  public errorCount: number = 0;
  public errorTotal: number = 0;
  public apiErrorCount: number = 0;
  public apiErrorTotal: number = 0;
  
  public currentProcessing: string = '';

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    console.log('UpdatingSheetDialog component initialized');
    
    // Initialize Office Add-in
    Office.onReady((info) => {
      console.log('Office Ready. Host:', info.host);
    });

    // Listen for messages from the parent component using Office API
    Office.context.ui.addHandlerAsync(Office.EventType.DialogParentMessageReceived, (arg: any) => {
      console.log('Message received from parent:', arg?.message);
      let payload: any = arg?.message;
      
      try {
        payload = JSON.parse(arg?.message);
        console.log('Parsed JSON payload:', payload);
      } catch {
        payload = arg?.message;
        console.log('Treating as string payload:', payload);
      }

      if (typeof payload === 'string') {
        this.message = !['', undefined, null].includes(payload) ? payload : this.message;
        console.log('Updated message to:', this.message);
      }

      if (payload && typeof payload === 'object') {
        console.log('Processing message object:', payload);
        
        if (typeof payload.message === 'string' && payload.message.trim() !== '') {
          this.message = payload.message;
          console.log('Updated message to:', this.message);
        }

        if (payload.isCompleted !== undefined) {
          console.log('Received isCompleted:', payload.isCompleted);
          this.isCompleted = payload.isCompleted;
          this.isLoading = !payload.isCompleted;
          console.log('Set isCompleted to:', this.isCompleted, 'isLoading to:', this.isLoading);
        }

        if (payload.successMessage !== undefined) {
          this.successMessage = payload.successMessage;
          console.log('Updated successMessage to:', this.successMessage);
        }

        if (payload.totalRecords !== undefined) {
          this.totalRecords = payload.totalRecords;
          console.log('Updated totalRecords to:', this.totalRecords);
        }

        if (payload.updatedRecords !== undefined) {
          this.updatedRecords = payload.updatedRecords;
          console.log('Updated updatedRecords to:', this.updatedRecords);
        }

        if (payload.submittedRecordCount !== undefined) {
          this.submittedRecordCount = payload.submittedRecordCount;
        }

        if (payload.remainingProcessingMinutes !== undefined) {
          this.remainingProcessingMinutes = payload.remainingProcessingMinutes;
        }

        if (payload.processingStatus !== undefined) {
          this.processingStatus = payload.processingStatus;
        }

        // Handle progress tracking for each type
        if (payload.publishedCount !== undefined) {
          this.publishedCount = payload.publishedCount;
          this.currentProcessing = 'published';
          console.log(`Published: ${this.publishedCount} of ${this.publishedTotal}`);
        }
        if (payload.publishedTotal !== undefined) {
          this.publishedTotal = payload.publishedTotal;
        }

        if (payload.deletedCount !== undefined) {
          this.deletedCount = payload.deletedCount;
          this.currentProcessing = 'deleted';
          console.log(`Deleted: ${this.deletedCount} of ${this.deletedTotal}`);
        }
        if (payload.deletedTotal !== undefined) {
          this.deletedTotal = payload.deletedTotal;
        }

        if (payload.errorCount !== undefined) {
          this.errorCount = payload.errorCount;
          this.currentProcessing = 'error';
          console.log(`Errors: ${this.errorCount} of ${this.errorTotal}`);
        }
        if (payload.errorTotal !== undefined) {
          this.errorTotal = payload.errorTotal;
        }

        if (payload.apiErrorCount !== undefined) {
          this.apiErrorCount = payload.apiErrorCount;
          this.currentProcessing = 'apiError';
          console.log(`API Errors: ${this.apiErrorCount} of ${this.apiErrorTotal}`);
        }
        if (payload.apiErrorTotal !== undefined) {
          this.apiErrorTotal = payload.apiErrorTotal;
        }
      }

      console.log('Triggering change detection');
      this.cd.detectChanges();
    });
  }

  public onOkClick(): void {
    console.log('OK button clicked - sending close action');
    // Use Office context to send message back to parent
    try {
      Office.context.ui.messageParent(JSON.stringify({ action: 'close' }));
    } catch (error) {
      console.error('Error sending message to parent:', error);
      // Fallback: try to close via window message
      window.parent.postMessage(JSON.stringify({ action: 'close' }), '*');
    }
  }
}



